/* eslint-disable check-file/filename-naming-convention -- index.ts does not follow the usual naming convention */
import {
  getOnboardingIllustrationIcon,
  OnboardingIllustrationName,
  OnboardingIllustrationSize,
  OnboardingIllustrationSizeConfig,
} from "@/ui/theme/icons/illustrations/onboarding/OnboardingIllustrationDefinitions";

export {
  getOnboardingIllustrationIcon,
  OnboardingIllustrationName,
  OnboardingIllustrationSize,
  OnboardingIllustrationSizeConfig,
};
